import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const tooltipMessage = (hasPermission, threadDeleted, threadFiltered) => {
  if (hasPermission === false) return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.reassignment.noPermission"
  });
  if (threadFiltered === true) return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.reassignment.threadFiltered"
  });
  if (threadDeleted === true) return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.reassignment.threadDeleted"
  });
  return undefined;
};
function CannotReassignTooltip({
  children,
  hasPermission,
  threadDeleted,
  threadFiltered
}) {
  const disabled = hasPermission && !threadDeleted && !threadFiltered;
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: disabled,
    title: tooltipMessage(hasPermission, threadDeleted, threadFiltered),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })
  });
}
CannotReassignTooltip.displayName = 'CannotReassignTooltip';
export default CannotReassignTooltip;